import { render } from "./pictcarousel.vue?vue&type=template&id=03b92133&scoped=true"
import script from "./pictcarousel.vue?vue&type=script&lang=js"
export * from "./pictcarousel.vue?vue&type=script&lang=js"

import "./pictcarousel.vue?vue&type=style&index=0&id=03b92133&lang=scss&scoped=true"
import "./pictcarousel.vue?vue&type=style&index=1&id=03b92133&lang=scss"
script.render = render
script.__scopeId = "data-v-03b92133"

export default script